/**
 * Получает ID объекта из текущего роута
 */
export const getObjectIdFromRoute = (route) => {
  const objectId = route.params?.objectId;

  if (!objectId) return null;

  return parseInt(objectId, 10);
};